import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {
    FormSearchLocationDiscountModel,
    LocationDiscountEntityRequest,
    LocationDiscountEntityResponse,
    LocationDiscountGetData
} from "../../pages/LocationDiscount/Types/locationDiscount";
import dayjs from "dayjs";
import axios from "axios";

export const useLocationDiscountRepository = () => {
    const {GET, POST, DELETE} = useApi();

    const PATH = "/pricing/location";
    const PATH2 = "pricing/location-discount"

    function getLocationDiscountPaged(filters: FormSearchLocationDiscountModel): Promise<PagedResponse<LocationDiscountEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH2}/paged/filter${queryParams ? query + queryParams : ""}`);
    }

    function getLocationDiscountDatas(legalEntities: string[], dealers: string[]): Promise<LocationDiscountGetData> {
        return GET(`${PATH}/discount-location-view?legalEntities=${legalEntities}&dealers=${dealers}`);
    }

    function postLocationDiscount(locationDiscount: LocationDiscountEntityRequest): Promise<any> {
        return axios.post(`${PATH2}/insert`, locationDiscount, {
            headers:
                {
                    'Content-Disposition': "attachment; filename=template.xlsx",
                    'Content-Type': 'application/json'
                },
            responseType: 'arraybuffer',
        });
    }

    function deleteLocationDiscount(id: number): Promise<string> {
        return DELETE(`${PATH2}?id=${id}`);
    }

    function downloadError(response: any) {
        try {
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
            const a = document.createElement('a'); // creiamo un elemento nel DOM
            const title = `location_discount_error_${dayjs().format("YYYYMMDDHHmm")}.xlsx`; // creiamo il titolo per il file

            a.href = url; // appendiamo l'url del Blob all'elemento creato
            a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
            a.click(); // aggiungiamo il click event per procedere al download
        } catch (e) {

        }
    }

    return {
        getLocationDiscountPaged,
        postLocationDiscount,
        deleteLocationDiscount,
        getLocationDiscountDatas,
        downloadError
    };
};